// Sign-up's one call, "Create my account" (room 1, plan task r1-signup; ai_app_backend's card R1-31), through the
// doorway (doorway.ts). With the `signup` area off, or this visitor outside its flag, it sends exactly what the sign-up
// screen sent before: POST v1's payments host /api/create_account with the attribution as JSON. On v2 it goes to
// v2's POST /v2/accounts, answered in v1's shape by signup-v2.ts. The area is placed by visitor id (switch.ts).
//
// The landing test ended on 23 Oct 2026 (Andy): every sign-up takes the same way, the landing test's old token or
// not (v2 accepts and ignores one; the website no longer sends any).
import { call, lazySide, signedInJson } from './doorway.ts'

const PATH = { payments: '/api/create_account' }

/**
 * Create the account for this sign-in, with how the person arrived (`attribution`, account-completion.js's
 * `accountAttribution`). `{ status: 'success', initialUserData, ... }` on 201 (made) or 200 (it existed).
 */
export const createAccount = (
  token: string,
  attribution: Record<string, unknown>,
  signal?: AbortSignal,
) =>
  call(
    'signup',
    PATH,
    {
      method: 'POST',
      headers: signedInJson(token),
      body: JSON.stringify(attribution),
      ...(signal ? { signal } : {}),
    },
    {
      token,
      side: lazySide(
        () => import('./signup-v2.ts'),
        (loaded) => loaded.createAccount,
        PATH,
      ),
    },
  )
